import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ECommerce = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="E Commerce" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-domains',
                            'text':'Business Domains'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>E Commerce</h2>
                        <h3>Turn Shoppers Into Buyers</h3>
                        <p>We focus on providing a great virtual customer service and a seamless online experience. Enhance your growth with our multifaceted e commerce development solutions.</p>
                        <h3>Sail Through It Smoothly</h3>
                        <p>Build, transform, and optimize. End goal of any business domain is to maximize profit while streamlining its operations. Be it a new one or updating an already existing e-shop we do it that too as per your requirements.</p>
                        <h3>Bring Your Brand On Forefront</h3>
                        <p>Validate your ideas and build a performance driven design of your product. We have industry specific templates for all kinds of business. You can choose the template that works best for you.</p>
                        <h3>Think Beyond Competition</h3>
                        <p>We merge innovation, content, creativity, and conversion to create master pieces that would make your e commerce stand apart from the competition in line with the industry trends.</p>
                        <h3>Here’s what our team has to offer</h3>
                        <h3>Custom Design</h3>
                        <p>We cater to customized website and mobile application development in both iOS and Android</p>
                        <h3>User Friendly Shopping Cart</h3>
                        <p>User friendly navigations prevent cart abandonment & make shopping experience a seamless one</p>
                        <h3>Secure Check Out Process</h3>
                        <p>Be it a single page checkout or specific scenario process we’ve got you covered.</p>
                        <h3>Product Catalogue Management</h3>
                        <p>Create product catalogue with flexible design and navigation aligned to your needs</p>
                        <h3>Order Management System</h3>
                        <p>Tailored to your business needs. Focus on growing your orders rather than managing them.</p>
                        <h3>CRM</h3>
                        <p>A goldmine that would help you determines potential sales opportunities.</p>
                        <h3>Social Media Integration</h3>
                        <p>Build brand awareness, communicate, and market your ecommerce business</p>
                        <h3>Payment Gateway Integration</h3>
                        <p>Integrate any kind of payment method and let your customers choose their favourite one</p>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ECommerce;